export const URGENCY_THRESHOLD = 3;
